<template>
  <div>
    <base-header
      class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
      style="
        min-height: 600px;
        background-size: cover;
        background-position: center top;
      "
    >
      <!-- Mask -->
      <span class="mask bg-gradient-success opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-12 col-md-10">
            <h1 class="display-2 text-white">Hola Usuario</h1>
            <p class="text-white mt-0 mb-5">
              Aquí puede gestionar los detalles de su rutina
            </p>
            <router-link to="/rutinas" class="btn btn-info"><span>Volver a rutinas</span></router-link>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-xl-12 order-xl-1">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-8">
                  <h3 class="mb-0">Detalles de la rutina</h3>
                </div>
                <div class="col text-right">
                  <router-link :to="{ name: 'Ejercicios rutina', params: { rutinaId: rutinaId, rutina_name: rutina_name}}"><base-button type="primary" size="sm"> Editar ejercicios</base-button></router-link>
                </div>
              </div>
            </div>
            <template>
              <form @submit.prevent="onFormSubmit">
                <div class="pl-lg-4">
                  <div class="row">
                    <div class="col-lg-6">
                      <small v-if="nombre_null" style="color:red;">Debe introducir el nombre de la rutina</small>
                      <base-input
                        alternative=""
                        label="Nombre"
                        placeholder="Nombre"
                        input-classes="form-control-alternative"
                        v-model="rutina_name"
                      />
                    </div>
                  </div>
                </div>
                <div class="pl-lg-4 row align-items-center">
                  <div class="col-lg-3 align-content-left">
                      <label for="">Fecha inicio:</label>
                      <small v-if="inicio_null" style="color:red;">Debe introducir el inicio de la rutina</small>
                    <base-input addon-left-icon="ni ni-calendar-grid-58">
                      <flat-picker
                        slot-scope="{ focus, blur }"
                        @on-open="focus"
                        @on-close="blur"
                        :config="{ allowInput: true, dateFormat: 'd-m-Y H:i' }"
                        class="form-control datepicker"
                        v-model="rutina_inicio"
                      >
                      </flat-picker>
                    </base-input>
                  </div>
                  <div class="col-lg-3 align-content-right">
                        <label for="">Fecha fin:</label>
                        <small v-if="fin_null" style="color:red;">Debe introducir cuando termina la rutina</small>
                        <base-input addon-left-icon="ni ni-calendar-grid-58">
                        <flat-picker slot-scope="{focus, blur}"
                                    @on-open="focus"
                                    @on-close="blur"
                                    :config="{allowInput: true, dateFormat: 'd-m-Y H:i'}"
                                    class="form-control datepicker"
                                    v-model="rutina_fin">
                        </flat-picker>
                    </base-input>
                  </div>
                </div>
                <hr class="my-4" />
                <!-- Address -->
                <h6 class="heading-small text-muted mb-4">
                  Detalles
                </h6>
                <div class="pl-lg-4">
                  <div class="row">
                    <div class="col-md-12">
                        <quill-editor  id="editor" conenteditable=true
                        ref="myQuillEditor"
                        :content="rutina_description"
                        :options="editorOption"
                        @blur="onEditorBlur($event)"
                        @focus="onEditorFocus($event)"
                        @ready="onEditorReady($event)"
                        @change="onEditorChange($event)"
                      />
                    </div>
                  </div>
                </div>
                <br>
                <button id="save" class="btn btn-primary btn-block">Guardar</button>
              </form>
            </template>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import  { db }  from '../../firebaseDb';
import { auth } from '../../firebaseDb';

export default {
  components: {flatPicker},
  name: "edit-rutina",
  props: {
        rutinaId: {
          type: String,
          defalut: "ASD"
        }
  },
  data() {
    return {
      user: auth.currentUser,
      dates: {
        fecha_inicio: "2020-11-01",
        fecha_fin: "2020-11-30",
      },
      rutina_name: "Nombre rutina",
      rutina_description: "Descripción de la rutina",
      rutina_inicio: "",
      rutina_fin: "",
      editorOption: {
           readOnly: false,
      },
      inicio_null: false,
      nombre_null: false,
      fin_null: false,
      
    };
  },
  methods: {
            onFormSubmit(event) {
                event.preventDefault();
                if (this.rutina_inicio == '' || this.rutina_inicio == null) {
                this.inicio_null = true;
                }else{
                  this.inicio_null = false;
                }

                if(this.rutina_name == "" || this.rutina_name == null || this.rutina_name == "Nombre rutina"){
                  this.nombre_null = true;
                }else{
                  this.nombre_null = false;
                }

                if(this.rutina_fin == null || this.rutina_fin == ""){
                  this.fin_null = true;
                }else{
                  this.fin_null = false;
                }
                if (this.fin_null == false && this.inicio_null == false && this.nombre_null == false) {
                    this.inicio_null = false;
                    this.nombre_null = false;
                    this.fin_null = false;
                    this.rutina_inicio = this.rutina_inicio.substring(6,10)+'-'+this.rutina_inicio.substring(3,5)+'-'+this.rutina_inicio.substring(0,2)+' '+this.rutina_inicio.substring(11,16)
                    console.log(this.rutina_inicio)
                    this.rutina_fin = this.rutina_fin.substring(6,10)+'-'+this.rutina_fin.substring(3,5)+'-'+this.rutina_fin.substring(0,2)+' '+this.rutina_fin.substring(11,16)
                    console.log(this.rutina_fin);
                    this.track();
                    db.collection('users').doc(this.user.uid).collection('rutinas').doc(this.rutinaId)
                    .update({
                      rutina_name: this.rutina_name,
                      rutina_description: this.rutina_description,
                      fecha_inicio: new Date (this.rutina_inicio),
                      fecha_fin: new Date (this.rutina_fin)
                    }).then(() => {
                        alert("Se ha editado correctamente");

                    }).catch((error) => {
                        console.log(error);
                    });
                }
            },
            onChange(val){
                //console.log(val);
            },
            onEditorBlur(quill) {
              console.log('editor blur!', quill)
            },
            onEditorFocus(quill) {
              console.log('editor focus!', quill)
            },
            onEditorReady(quill) {
              console.log('editor ready!', quill)
            },
            onEditorChange({ quill, html, text }) {
              console.log('editor change!', quill, html, text)
              this.rutina_description = html
            },
            track() {
              this.$gtag.event("edited_rutina", {
              'event_category': "rutina",
              'event_label': "rutina_edited",
              'value': 1
              })
            },  
  },
  created: function() {
    var self = this
    db.collection('users').doc(this.user.uid).collection('rutinas').doc(this.rutinaId).get()
    .then(function(doc){
      if(doc.exists){
        try{
          let rutinaName = doc.data().rutina_name
          self.rutina_name = rutinaName

          let rutinaDesc = doc.data().rutina_description
          self.rutina_description = rutinaDesc

          let rutinaInicio = doc.data().fecha_inicio
           rutinaInicio = rutinaInicio.toDate()
          self.rutina_inicio = rutinaInicio

          let rutinaFin = doc.data().fecha_fin
           rutinaFin = rutinaFin.toDate()
          self.rutina_fin = rutinaFin
        }catch(error){
          console.log(error)
        }
      }
    })
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill
    }
  },
  mounted() {
    console.log('this is current quill instance object', this.editor)
  },
};
</script>
<style>
#editor{
  height: 500px;
}

#save{
  margin-top: 105px;
}
</style>